import { SearchIndexCourseFilters } from '@shared/types';
import Link from 'next/link';
import { FunctionComponent, MouseEvent, useCallback } from 'react';
import { UrlObject } from '../../../../hooks/useRouterState';
import FacetFilterSection from '../FacetFilterSection';
import styles from './styles.module.scss';
import DeliveryFilter from '../../../../components/DeliveryFilter';

export type DeliveryFilterSectionProps = {
    value: SearchIndexCourseFilters['delivery'];
    onChange: (newValue: SearchIndexCourseFilters['delivery']) => void;
    getFilterLink: (newValue: SearchIndexCourseFilters['delivery']) => UrlObject;
};

export const DeliveryFilterSection: FunctionComponent<DeliveryFilterSectionProps> = ({
    value,
    onChange,
    getFilterLink,
}) => {
    const renderOptionLabel = useCallback(
        (option: {
            value: NonNullable<SearchIndexCourseFilters['delivery']>;
            label: string;
            isSelected: boolean;
        }) => {
            const { value, label } = option;
            const filterLink = getFilterLink(value);
            const onClick = (event: MouseEvent<any, globalThis.MouseEvent>) => {
                event.preventDefault();
                onChange(value);
            };
            return (
                <Link className={styles.link} href={filterLink} onClick={onClick} rel="nofollow">
                    {label}
                </Link>
            );
        },
        [getFilterLink, onChange]
    );

    return (
        <FacetFilterSection
            name="Delivery"
            ariaLabel="Filter by delivery method"
            numberOfIntiallyVisible={Infinity}
        >
            <li>
                <DeliveryFilter
                    value={value}
                    onChange={onChange}
                    renderOptionLabel={renderOptionLabel}
                />
            </li>
            <></>
        </FacetFilterSection>
    );
};
